// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumbs--wrapper","link":"Breadcrumbs--link","delimeter":"Breadcrumbs--delimeter"};